import { useEffect, useRef } from 'react';
import { useMutation } from 'convex/react';
import { isSameDay } from 'date-fns';
import { api } from '@bill-alps/backend/convex/_generated/api';
import { useCurrentUser } from './use-current-user';

// Stamps users.lastSeenAt once per local calendar day so the admin dashboard
// can see returning users even when they create nothing. The server adds a
// 1h guard against multi-tab races; failures are swallowed so app load never
// breaks.
export function useHeartbeat() {
  const { user, isLoading } = useCurrentUser();
  const heartbeat = useMutation(api.features.users.accounts.heartbeat);
  const firedRef = useRef(false);

  useEffect(() => {
    if (isLoading || !user || firedRef.current) return;
    if (user.lastSeenAt && isSameDay(user.lastSeenAt, Date.now())) return;
    firedRef.current = true;
    heartbeat().catch(() => undefined);
  }, [isLoading, user, heartbeat]);
}
